import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { Tool } from '../types/database'

export function useTools() {
  const [tools, setTools] = useState<Tool[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchTools() {
      try {
        setLoading(true)
        // In a real app with Supabase connected, this would fetch data
        // const { data, error } = await supabase
        //   .from('tools')
        //   .select('*')
        //   .order('created_at', { ascending: false })

        // if (error) throw error
        // setTools(data || [])

        // For now, we'll return empty array or mock data if needed
        // But the structure is ready for Supabase
        setTools([])
      } catch (err: any) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchTools()
  }, [])

  const getFeaturedTools = () => tools.filter((tool) => tool.is_featured)
  const getToolsByCategory = (category: string) =>
    category === 'all'
      ? tools
      : tools.filter((tool) => tool.category === category)

  return { tools, loading, error, getFeaturedTools, getToolsByCategory }
}
